import React, {useEffect, useState} from "react";
import {Button, Avatar, Pagination} from "antd";
import Modal from 'react-bootstrap/Modal';
import ApiService from "../util/ApiService"; // Certifique-se de ajustar o caminho conforme necessário
import Swal from "sweetalert2";
import './assets/css/SelectPlantonistaModal.css';
import CustomPagination from "../util/CustomPagination";
import LoadingScreen from "../util/LoadingScreen";

const SelectPlantonistaModal = ({show, handleClose, duty}) => {
    const [loadingPage, setLoadingPage] = useState(false);
        const [pagination, setPagination] = useState({current: 1, pageSize: 10, total: 0, lastPage: 0});
        const [dutyManage, setDutyManage] = useState([]);
        const [visible, setVisible] = useState(false);

        useEffect(() => {
            if(show && duty) {
                handlePlantonistAll(1);
            }else{
                setVisible(false);
            }
        }, [show, duty]);


      const handlePlantonistAll = async (page) => {
            try {
                setLoadingPage(true);
                const response = await ApiService.send("get", process.env.REACT_APP_URL_API + 'duty/manageDutyAcceptance',
                    {
                        id: duty.id,
                        page: page,
                        pagination: pagination.pageSize
                    }, true
                );
                // Se não for exportação, trata a resposta JSON normalmente
                const {data, pagination: pagInfo} = ApiService.handleApiResponse(response);
                setDutyManage(data || []);
                setPagination(pagInfo || {current: 1, pageSize: 10, total: 0});



            } catch (error) {
                handleClose();
                ApiService.handleApiError(error);
            }finally {
                setLoadingPage(false);
            }
        }


        const handlePlantonistaSelect = async (plantonistaId) => {
            try {
                await ApiService.send("post", process.env.REACT_APP_URL_API + 'duty/acceptUser', {
                    duty_id: duty.id,
                    user_id: plantonistaId,
                });
                Swal.fire({
                    title: 'Sucesso!',
                    text: 'Plantonista selecionado com sucesso!',
                    icon: 'success',
                    confirmButtonText: 'OK'
                }).then(function () {
                    handleClose(true);
                });
            } catch (error) {
                ApiService.handleApiError(error);
            }
        };


        return (
            <>


            <Modal show={show} onHide={handleClose} centered size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Selecionar plantonista</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <div>
                            {loadingPage ? (
                                <div className="text-center my-4">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Carregando...</span>
                                    </div>
                                    <p className="mt-2">Buscando plantonistas interessados...</p>
                                </div>
                            ) : dutyManage.length === 0 ? (
                                <div className="alert alert-info text-center mt-3" role="alert">
                                    Nenhum plantonista interessado encontrado.
                                </div>
                            ) : (
                                <>
                                    {dutyManage.map((manage) => (
                                        <div key={manage.user.id}
                                             className="user-item mb-3 p-3 bg-white rounded shadow-sm">
                                            <div className="d-flex align-items-center w-100">
                                                <Avatar
                                                    src={manage.user.profile_image || process.env.REACT_APP_URL_STORAGE + 'src/perfil_icone.png'}
                                                    size={105}
                                                    className="mr-4"
                                                />
                                                <div className="user-details">
                                                    <h5 className="mb-1">{manage.user.name}</h5>
                                                    <p className="mb-1">{`${manage.user.city || ''} - ${manage.user.ddd || ''}  ${manage.user.phone || ''}`}</p>
                                                    <p className="mb-1">
                                                        <i className="fa fa-calendar-check-o"
                                                           aria-hidden="true"></i>{" "}
                                                        Data
                                                        Interesse: {new Date(manage.accept_date_time).toLocaleString('pt-BR')}
                                                    </p>
                                                </div>
                                                <div className="button-container">
                                                    <button type="button" className="btn btn-primary btn-sm"
                                                            onClick={() => handlePlantonistaSelect(manage.user.id)}>
                                                        <i className="fa fa-check"></i> Aprovar
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    <CustomPagination
                                        className="mt-4"
                                        pagination={pagination}
                                        onChange={(page) => handlePlantonistAll(page)}
                                    />
                                </>
                            )}
                        </div>

                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary"  onClick={() => handleClose(false)} >
                        <i className="fa fa-close"></i>{" "}Fechar
                    </button>
                </Modal.Footer>
            </Modal>
            </>
        );
    }
;

export default SelectPlantonistaModal;
